import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { mediaQueries } from '../../constants/breakpoints';

const desktopExpanded = css`
  width: 208px;
  min-width: 208px;
`;

const desktopCollapsed = css`
  width: 56px;
  min-width: 56px;
  overflow: hidden;
  & a {
    margin: 0 4px 10px 4px;
    padding: 12px;
    justify-content: center;
  }
  & a img {
    width: 24px;
    height: 24px;
  }
  & a > span:last-child {
    display: none;
  }
`;

export const Wrap = styled.div<{ $isActive?: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 61px;
  left: 0;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 1;
  @media ${mediaQueries.mediumDesktop} {
    display: none;
  }
  ${(props) =>
    props.$isActive
      ? `
      display:block;
    `
      : `
      display:none;
    `}
`;

export const Container = styled.div<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: #ecf3f9;
  position: fixed;
  width: 208px;
  min-width: 208px;
  height: calc(100% - 61px);
  top: 61px;
  justify-content: space-between;
  z-index: 2;
  padding-top: 30px;
  transform: translateX(-208px);
  transition: transform 0.2s;
  ${(props) =>
    props.$isActive
      ? `
      transform: translateX(0);
    `
      : ''}
    @media ${mediaQueries.desktop} {
    height: 100%;
    overflow-y: auto;
    position: relative;
    top: 0;
    transform: translateX(0);
    ${(props) => (props.$isActive ? desktopExpanded : desktopCollapsed)}
  }
  @media ${mediaQueries.mobile} {
    overflow-y: auto;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const LogoLink = styled(Link)`
  display: block;
  margin: 0 auto 15px;
  width: 100%;
  text-align: center;
`;

export const StyledLink = styled(Link)<{ $isActive?: boolean; to?: string }>`
  display: flex;
  align-items: center;
  color: #334d6e;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.2s;
  margin: 0 28px 10px 16px;
  border-radius: 50px;
  padding: 6px 12px;

  svg {
    color: #334d6e;
    font-size: 24px;
  }

  span {
    margin-left: 10px;
  }

  :hover {
    text-decoration: none;
    background-color: #bde5eb;
  }

  ${(props) =>
    props.$isActive
      ? `
    background-color: #BDE5EB;
  `
      : ''}
`;

export const StyledSubLink = styled(StyledLink)`
  margin-left: 50px;
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;

  button {
    min-width: 48%;
    margin-bottom: 30px;
  }
`;

export const Title = styled.h3`
  text-align: center;
  color: #334d6e;
`;
